import { useCallback } from 'react';
import logReactError from '../ErrorBoundaries/logReactError';
import { useAppConfiguration } from './useAppConfiguration';
export function useLogError() {
  const {
    appName,
    appVersion,
    loggerBaseApiUrl
  } = useAppConfiguration();
  const logError = useCallback(function logError(message) {
    return logReactError({
      appName,
      appVersion,
      loggerBaseApiUrl
    }, {
      message,
      stack: null
    });
  }, [appName, appVersion, loggerBaseApiUrl]);
  return logError;
}